import Vue from 'vue';
import * as Tone from 'tone';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.prototype.$Tone = Tone;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
